module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("お問合わせ一覧")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-sm-3 form-horizontal"
  }, [_c('contact-search', {
    on: {
      "click": _vm.contactSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: " col-sm-9"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("問合せ日時")]), _vm._v(" "), _c('th', [_vm._v("氏名")]), _vm._v(" "), _c('th', [_vm._v("メールアドレス")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.contacts), function(contact) {
    return [_c('contact-list-row', {
      attrs: {
        "contact": contact
      }
    })]
  })], 2)]), _vm._v(" "), _c('pager', {
    attrs: {
      "pager": _vm.pager
    },
    on: {
      "click": _vm.clickPager
    }
  })], 1)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22144595"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact/List.vue
// module id = 441
// module chunks = 1